import { primaryThemeColors } from "./primaryThemeColors";

const primary = {
  colors: primaryThemeColors,
};

export default primary;
